import styles from '@components/components/AddressPicker/AddressPicker.module.scss';
import React from 'react';
import { FontAwesomeProIcon } from '@wienenergiegithub/ui-next';
import classNames from 'classnames';
import { Menu, MenuItem, MenuButton } from '@ariakit/react';

const Suggestions = ({ store, suggestions, onClick }) => {
  const handleOnClick = item => () => {
    onClick(item);
    store.hide();
  };

  if (suggestions?.length < 1) {
    return null;
  }

  return (
    <>
      <MenuButton className={styles.menuButton} store={store} />
      <Menu aria-label="Vorschläge" className={styles.menu} store={store}>
        <span className={styles.menuHeading}>Vorschläge</span>
        {suggestions?.map(item => (
          <MenuItem
            className={classNames(styles.menuItem, styles[item.type])}
            key={`${item.value}${item.label}`}
            onClick={handleOnClick(item.value)}
            store={store}
          >
            {item.icon && (
              <FontAwesomeProIcon
                className={styles.mapMarkerIcon}
                icon="map-marker-alt"
                type="regular"
              />
            )}
            {item.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default Suggestions;
